export const MerchantLabel = {
    SUPPLIER: 'Supplier',
    SENDER: 'Sender'
};
